export class CurrencyRequest{
    currencyId:number;
    
    constructor(currencyId:number){
        this.currencyId = currencyId;
    }
}